import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useT } from "@/i18n/LanguageProvider";
import Chevron from "./Chevron";

export default function CTABanner({
  title,
  subtitle,
  primaryLabel,
  primaryTo = "/track",
  secondaryLabel,
  secondaryTo = "/contact",
}) {
  const t = useT();
  const finalTitle = title ?? t.ctaBanner.title;
  const finalSubtitle = subtitle ?? t.ctaBanner.subtitle;
  const finalPrimary = primaryLabel ?? t.ctaBanner.primary;
  const finalSecondary = secondaryLabel ?? t.ctaBanner.secondary;
  const bullets = t.ctaBanner.bullets || [];
  const bulletsHeading = t.ctaBanner.bulletsHeading;

  return (
    <section className="relative bg-delfi-navy text-white overflow-hidden" data-testid="cta-banner">
      <div className="chevron-bg right-[-10%] top-[-40%] opacity-[0.08]" aria-hidden="true">›</div>
      <div className="absolute inset-0 grid-pattern opacity-30" aria-hidden="true" />
      <div className="delfi-container relative py-20 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] gap-12 items-start">
          <div>
            <div className="inline-flex items-center gap-2 text-delfi-red text-xs tracking-[0.18em] uppercase font-semibold">
              <Chevron size={14} /> {t.ctaBanner.eyebrow}
            </div>
            <h2 className="headline-section text-3xl md:text-5xl text-white mt-4" data-testid="cta-banner-title">
              {finalTitle}
            </h2>
            <p className="mt-5 text-white/75 text-lg max-w-xl leading-relaxed">{finalSubtitle}</p>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link to={primaryTo} className="btn-delfi-primary" data-testid="cta-banner-primary">
                {finalPrimary} <ArrowRight size={18} />
              </Link>
              <Link to={secondaryTo} className="btn-delfi-ghost" data-testid="cta-banner-secondary">
                {finalSecondary}
              </Link>
            </div>
          </div>

          {bullets.length > 0 && (
            <div
              className="rounded-2xl p-7 md:p-8 bg-white/[0.04] border border-white/10 backdrop-blur-sm"
              data-testid="cta-banner-bullets"
            >
              {bulletsHeading && (
                <p className="text-[11px] uppercase tracking-[0.2em] text-white/55 font-semibold mb-5">
                  {bulletsHeading}
                </p>
              )}
              <ul className="space-y-4">
                {bullets.map((b, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-delfi-red/20 text-delfi-red flex items-center justify-center shrink-0 mt-0.5">
                      <Check size={14} strokeWidth={3} />
                    </span>
                    <span className="text-white/85 text-[15px] leading-relaxed">{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
